import { Outlet } from 'react-router';

import { ContactModal } from './components/contact-modal.tsx';
import { Footer } from './components/footer.tsx';
import { ModalsProvider } from './components/modals.tsx';
import { Navbar } from './components/navbar.tsx';
import { SuggestionBubbleButton } from './components/suggestion-bubble-button.tsx';
import { SuggestionModal } from './components/suggestion-modal.tsx';

export default function Layout() {
  return (
    <ModalsProvider>
      <div className="flex min-h-screen flex-col scroll-smooth">
        <Navbar />
        <main className="grow">
          <Outlet />
        </main>
        <Footer />
      </div>
      <SuggestionBubbleButton />
      <ContactModal />
      <SuggestionModal />
    </ModalsProvider>
  );
}
